import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    ...shorthands.gap("12px"),
    marginBottom: "8px",
    backgroundColor: tokens.colorNeutralBackground1,
    ":first-child": {
      ...shorthands.borderRadius("4px", "4px", "0px", "0px"),
    },
    ":last-child": {
      ...shorthands.borderRadius("0px", "0px", "4px", "4px"),
      ...shorthands.borderBottom("none"),
    },
    ":only-child": {
      ...shorthands.borderRadius("4px"),
      ...shorthands.borderBottom("none"),
    },
    boxShadow: tokens.shadow4,
  },
  purple: {
    backgroundColor: tokens.colorBrandForeground1,
  },
  red: {
    backgroundColor: tokens.colorPaletteRedBackground3,
  },
  details: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    width: "100vw",
    ...shorthands.overflow("auto"),

    ":first-child": {
      ...shorthands.borderRadius("4px", "4px", "0px", "0px"),
    },
    ":last-child": {
      ...shorthands.borderRadius("0px", "0px", "4px", "4px"),
      ...shorthands.borderBottom("none"),
    },
    ":only-child": {
      ...shorthands.borderRadius("4px"),
      ...shorthands.borderBottom("none"),
    },
  },
  text: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    ...shorthands.overflow("hidden"),
    maxWidth: "calc(100vw - 48px)",
  },
  smalltext: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase200,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightRegular,
    ...shorthands.overflow("hidden"),
    maxWidth: "calc(100vw - 48px)",
  },
  whitetext: {
    color: tokens.colorNeutralBackground1,
  },

  orderSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "33%",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  rightAlignment: {
    alignItems: "end",
  },
  icon: {
    width: "24px",
    height: "24px",
  },
});
